import axios from 'axios';
import { useAuth } from '../../context/AuthContext';

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const useAdminApi = () => {
  const { token } = useAuth();
  const adminHeaders = () => ({ Authorization: `Bearer ${token}` });

  const adminApi = (method, url, data) => {
    const config = { method, url: `${API}${url}`, headers: adminHeaders() };
    if (data !== undefined) config.data = data;
    return axios(config);
  };

  return { adminApi, adminHeaders };
};
